import { Injectable } from "@nestjs/common";
import { FinishEntity } from "./finish.entity";
import { InjectDataSource, InjectRepository } from "@nestjs/typeorm";
import { DataSource, Repository } from "typeorm";
import { CategoryIdRequest, CommonResponseModel } from "@project-management-system/shared-models";
import { FinishDTO } from "./dto/finish.dto";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { M3TrimsCategoryMappingRepo } from "../../m3-trims/m3-trims-category-mapping.repo";
import { CategoryMappingEntity } from "../../m3-trims/m3-trims-category-mapping.entity";

@Injectable()
export class FinishService {
    constructor(
      
        @InjectRepository(FinishEntity)
        private finishRepo: Repository<FinishEntity>,
        private m3TrimsCategoryMappingRepo:M3TrimsCategoryMappingRepo,
        @InjectDataSource()
    private datasource: DataSource
    ){}
  
  
      async getAllFinish(): Promise<CommonResponseModel> {
        try {
            const data = await this.finishRepo.find({order:{finish:"ASC"}})
            if(data.length > 0){
                return new CommonResponseModel(true, 1, 'Finish data retrieved successfully',data)
            }else{
                return new CommonResponseModel(false, 0, 'No data found',[])
            }
        } catch (err) {
          return err;
        }
      }

      async createFinish(req: FinishDTO, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
          const manager = this.datasource;
          let existingCategoryCode;

          if(!isUpdate){
            const query =` SELECT  trim_category,f.finish FROM category_mapping cm
 LEFT JOIN finish f ON f.finish_id = cm.finish_id
 where f.finish ='${req.finish}' AND cm.trim_category = ${req.trimCategoryId}`
 const existingCategory = await manager.query(query)
 if (existingCategory.length > 0 ) {
  throw new Error('Category Already Exists');
} else if (existingCategoryCode) {
  throw new Error('Category Code already exists');
}
          }else{
            const finishDetails = await this.finishRepo.findOne({ where: { finish: req.finish } })
            if (finishDetails) {
              return new CommonResponseModel(false, 1, 'Finish already exists')
            } 
            const details = await this.finishRepo.findOne({ where: { finishCode: req.finishCode } })
            if (details) {
              return new CommonResponseModel(false, 1, 'Finish Code already exists')
            } 
            
          }
        
          const entity = new FinishEntity();
          // entity.type = req.type
          entity.finish = req.finish;
          entity.finishCode = req.finishCode;
          if (isUpdate) {
            entity.finishId = req.finishId;
            entity.updatedUser = req.username;
          } else {
            entity.createdUser = req.username;
          }
          const savedResult = await this.finishRepo.save(entity)
          if (savedResult && !isUpdate) {
            let reqData = new CategoryMappingEntity();
            reqData.trimCategory = req.trimCategoryId;
            reqData.finishId = savedResult.finishId;
            // console.log(reqData)
            const mapCategory = await this.m3TrimsCategoryMappingRepo.save(reqData);
            // console.log(mapCategory);
            if(mapCategory.categoryMappingId > 0){
                return new CommonResponseModel(true, 0, isUpdate ? 'Finish updated successfully' : 'Finish created successfully', [savedResult])
            }
            else{
                return new CommonResponseModel(false, 0, "Something went wrong. ")
            }
        } 
        else if (savedResult && isUpdate) {
          return new CommonResponseModel(true, 0, isUpdate ? 'Finish updated successfully' : 'Finish created successfully', [savedResult])
        }
        else {
            return new CommonResponseModel(false, 0, 'Something Went Wrong');
        }
        } catch (err) {
          throw err;
        }
      }

      async activateOrDeactivateFinish(req: FinishDTO): Promise<CommonResponseModel> {
        try {
            const finishExists = await this.finishRepo.findOne({where:{finishId: req.finishId}});
            if (finishExists) {
                if (!finishExists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Finish information. Refresh and try again');
                } else {
                    
                        const finishStatus =  await this.finishRepo.update(
                            { finishId: req.finishId },
                            { isActive: req.isActive,updatedUser: req.updatedUser });
                       
                        if (finishExists.isActive) {
                            if (finishStatus.affected) {
                                const response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Finish is deactivated successfully');
                                return response;
                            } else {
                                throw new CommonResponseModel(false,10111, 'Finish is already deactivated');
                            }
                        } else {
                            if (finishStatus.affected) {
                                const response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Finish is activated successfully');
                                return response;
                            } else {
                                throw new CommonResponseModel(false,10112, 'Finish is already activated');
                            }
                      }
                }
            } else {
                throw new CommonResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
      }


      async getAllActiveFinish(): Promise<CommonResponseModel> {
        try {
            const data = await this.finishRepo.find({where:{isActive: true},order:{finish:"ASC"}})
            if(data.length > 0){
                return new CommonResponseModel(true, 1, 'Finish data retrieved successfully',data)
            }else{
                return new CommonResponseModel(false, 0, 'No data found',[])
            }
        } catch (err) {
          return err;
        }
      }

      async getFinishById(req:FinishDTO): Promise<CommonResponseModel> {
        try {
            const data = await this.finishRepo.find({where:{finishId: req.finishId,isActive: true}})
            if(data.length > 0){
                return new CommonResponseModel(true, 1, 'Finish data retrieved successfully',data)
            }else{
                return new CommonResponseModel(false, 0, 'No data found',[])
            }
        } catch (err) {
          return err;
        }
      }

      async getFabricFinishData():Promise<CommonResponseModel>{
        try{
          let query = `
          SELECT finish, finish_code AS finishCode,item_type,finish_id AS finishId
          FROM finish
          WHERE item_type = 'Fabric'`
          const data = await this.datasource.query(query)
          if(data.length>0){
            return new CommonResponseModel(true, 0, 'Data retrieved successfully',data)
          }else{
            return new CommonResponseModel(false, 1, 'No data found',[])
          }
        }catch(err){
          throw(err)
        }
      }
      async getAllActiveForCategoryFinish(req:CategoryIdRequest): Promise<CommonResponseModel> {
        try {
            const data = await this.m3TrimsCategoryMappingRepo.getAllFinishByCategory(req.categoryId)
            if(data.status){
                return new CommonResponseModel(true, 1, 'Finish data retrieved successfully',data.data)
            }else{
                return new CommonResponseModel(false, 0, 'No data found',[])
            }
        } catch (err) {
          return err;
        }
      }

}
